import React,{useState,useImperativeHandle,forwardRef,useEffect} from 'react'
import { Modal, message, Pagination, Empty, Input, Table, Radio, Button } from 'antd';
import { allProductList, selectProductList } from '@/services/product';
import { ResDataType } from "@/services/ajax";
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { productDataType,column } from './column';
import type { TableProps } from 'antd';
import { debounce } from "@/utils";
import { productGradeList } from "@/constant"
import { DataType } from '@/pages/activities/components/column';
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

 const ProductList = (props:{selectedData:DataType[], callback: (selectProducts:productDataType[])=>void},ref:any) => {
    const { callback,selectedData } = props;
    const [data,setData] = useState<productDataType[]>([]);
    const [name,setName] = useState('');
    const [grade,setGrade] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState<productDataType[]>([]);
    const { page,setPage,pageSize,setPageSize,total,setTotal,flag,setFlag,isModalOpen, setIsModalOpen } = usePagAndCommon();
    const showModal = () => {
      setIsModalOpen(true);
      setGrade('');
      setName('');
      setPage(1);
      fetchData('',1,'');
    };
    
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const debouncedSearch = debounce((value:string,pageIndex:number) => {
        fetchData(value,pageIndex || page,grade)
    }, 500);

    const handleSearch = (value:string,page:number) => {
        debouncedSearch(value,page);
    };
    const fetchData = async (value:string,pageIndex:number,grade:string='') => {
        setFlag(true);
        setPage(pageIndex)
        const res = await allProductList(pageIndex,pageSize,grade,value) as ResDataType;
        if (res.code!= 0) {
          message.error(res.message);
          return;
        } 
        setData(res.data.list);
        setTotal(res.data.total);
        setFlag(false)
    }
    const selectProduct = (selectProducts:productDataType[]) => {
        callback(selectProducts);
        setSelectedRowKeys([]);
        setIsModalOpen(false);
    }
    
    useImperativeHandle(ref, () => ({
        open: () => showModal(),
    }))

    const onSelectChange = (newSelectedRowKeys: React.Key[],selectedRows:productDataType[]) => {
        setSelectedRowKeys(selectedRows);
      };
    
      const rowSelection: TableRowSelection<productDataType> = {
        selectedRowKeys:selectedRowKeys.map((row:productDataType) => row.productId),
        onChange: onSelectChange,
        getCheckboxProps: (record:productDataType) => ({
          disabled: selectedData.some(ite=> ite.productId == record.productId), // 禁用已下架的权益 
        })
      };

    return(
        <Modal maskClosable={false} width={850} title="选择权益" open={isModalOpen} okText='确定' cancelText="取消" onOk={()=>{
            if (selectedRowKeys.length == 0) {
                message.warning('请先选择权益');
                return;
            }
            selectProduct(selectedRowKeys)
        }} onCancel={handleCancel}>
            <div className='flexBox' style={{ justifyContent:'space-between',marginBottom:'15px', }}>
                <Input value={name} placeholder='权益名称' allowClear 
                style={{ width:'50%'}}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value;
                    setName(value);
                    handleSearch(value,1);
                }} />
                <div>
                    <span style={{ marginRight:'20px' }}>权益档次：</span>
                    <Radio.Group
                        value={grade}
                        onChange={(e)=>{
                            setGrade(e.target.value);
                            fetchData(name,1,e.target.value);
                        }}
                        options={productGradeList}
                        />
                </div>
                <Button type="primary" onClick={()=>{
                    setName('');
                    setGrade('');
                    fetchData('',1,'');
                }} >重置</Button>
            </div>
            <div style={{height:'50vh',overflow:'auto'}}>
                <Table<productDataType>
                rowKey='productId'
                pagination={false}
                loading={flag}
                scroll={{ x: 'max-content', y: 380 }}
                locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
                rowSelection={rowSelection} columns={column} dataSource={data} />
            </div>
            
            <Pagination align="center" showTotal={(total:number) => `共${total}条`} showSizeChanger={false} defaultCurrent={page} current={page} pageSize={pageSize} total={total} onChange={(e)=>{ setPage(e);fetchData(name,e,grade); }} />
        </Modal>
    )
}

export default forwardRef(ProductList)